import React from "react";

const Footer = (props: any) => {

    return (
        <footer id="footer">

            <div className="footer-top">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-3 col-md-6 footer-contact">
                            <h3>RSoft</h3>
                            <p>
                                La Paz<br/>
                                Bolivia <br/><br/>
                                <strong>Phone:</strong> +591 70141160<br/>
                                <strong>Email:</strong> rikiricardo16@hotmail.com<br/>
                            </p>
                        </div>

                        <div className="col-lg-2 col-md-6 footer-links">
                            <h4>Useful Links</h4>
                            <ul>
                                <li><i className="bx bx-chevron-right"/> <a href="#">Home</a></li>
                                <li><i className="bx bx-chevron-right"/> <a href="#">About us</a></li>
                                <li><i className="bx bx-chevron-right"/> <a href="#">Services</a></li>
                                <li><i className="bx bx-chevron-right"/> <a href="#">Terms of service</a></li>
                                <li><i className="bx bx-chevron-right"/> <a href="#">Privacy policy</a></li>
                            </ul>
                        </div>

                        <div className="col-lg-3 col-md-6 footer-links">
                            <h4>Our Services</h4>
                            <ul>
                                <li><i className="bx bx-chevron-right"/> <a href="#">Web Design</a></li>
                                <li><i className="bx bx-chevron-right"/> <a href="#">Blockchain</a></li>
                                <li><i className="bx bx-chevron-right"/> <a href="#">Web Development</a></li>
                                <li><i className="bx bx-chevron-right"/> <a href="#">Mobile Development</a></li>
                                <li><i className="bx bx-chevron-right"/> <a href="#">Backend Development</a></li>
                            </ul>
                        </div>

                        <div className="col-lg-4 col-md-6 footer-newsletter">
                            <h4>Join Our Newsletter</h4>
                            <p>Tamen quem nulla quae legam multos aute sint culpa legam noster magna</p>
                            <form action="" method="post">
                                <input type="email" name="email"/>
                                <input type="submit" value="Subscribe"/>
                            </form>
                        </div>

                    </div>
                </div>
            </div>

            <div className="container">

                <div className="copyright-wrap d-md-flex py-4">
                    <div className="me-md-auto text-center text-md-start">
                        <div className="copyright">
                            &copy; Copyright <strong><span>RSoft</span></strong>. All Rights Reserved
                        </div>
                        <div className="credits">
                            Designed by <a href="https://bootstrapmade.com/">RSoft</a>
                        </div>
                    </div>
                    <div className="social-links text-center text-md-right pt-3 pt-md-0">
                        <a href="https://twitter.com/rsoft_latam" className="twitter">
                            <i className="bx bxl-twitter"/></a>
                        <a href="https://www.facebook.com/RsoftLatam" className="facebook">
                            <i className="bx bxl-facebook"/></a>
                        <a href="https://www.youtube.com/c/rsoftlatam" className="youtube">
                            <i className="bx bxl-youtube"/></a>
                        <a href="https://github.com/rsoft-latam" className="github">
                            <i className="bx bxl-github"/></a>
                        <a href="https://www.linkedin.com/in/ricardo-pari-534070139" className="linkedin">
                            <i className="bx bxl-linkedin"/></a>
                        <a href="https://www.instagram.com/rsoft_latam" className="instagram">
                            <i className="bx bxl-instagram"/></a>
                    </div>
                </div>

            </div>
        </footer>
    );

}

export default Footer;
